<template>
  <div class="tip-content">
    <p class="explain1">经纪商持股比例=经纪商持仓股数/已发行股数</p>
    <p class="explain2">持股比例最高的几个经纪商，其持股比例的变化，一定程度能反映机构投资者对后市股价的态度。</p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.tip-content {
  text-align: left;
  .explain1 {
    margin-bottom: 20px;
  }
}
</style>
